import React, { useState, useContext, useEffect } from 'react'
import GameContext from '../context/game/GameContext'

function Dashboard() {
    const [dashboardEntry, setdashboardEntry] = useState([])
    const context = useContext(GameContext)
    const { getDashboardEntry } = context
    useEffect(() => {
        getDashboardEntry(setdashboardEntry)
    }, [])
    const [activeKey, setActiveKey] = useState("Easy")
    return (

        <div class="m-4 relative overflow-x-auto shadow-md shadow-black">
            <div class="flex justify-between text-base font-bold text-gray-700 uppercase bg-rose-400">
                <button scope="col" class={`shadow-sm shadow-black w-full px-6 py-3 ${activeKey === "Easy" ? "bg-blue-400" : ""}`} onClick={() => setActiveKey("Easy")}>
                    Easy
                </button>
                <button scope="col" class={`shadow-sm shadow-black w-full px-6 py-3 ${activeKey === "Medium" ? "bg-blue-400" : ""}`} onClick={() => setActiveKey("Medium")}>
                    Medium
                </button>
                <button scope="col" class={`shadow-sm shadow-black w-full px-6 py-3 ${activeKey === "Hard" ? "bg-blue-400" : ""}`} onClick={() => setActiveKey("Hard")}>
                    Hard
                </button>
            </div>
            <table class="w-full text-sm text-left text-gray-500">
                <thead class="text-xs text-gray-700 uppercase bg-rose-200">
                    <tr>
                        <th scope="col" class="px-6 py-3">
                            User ID
                        </th>
                        <th scope="col" class="px-6 py-3">
                            User Name
                        </th>
                        <th scope="col" class="px-6 py-3">
                            Game Id
                        </th>
                        <th scope="col" class="px-6 py-3">
                            Date
                        </th>
                        <th scope="col" class="px-6 py-3">
                            Game Completed in time
                        </th>
                    </tr>
                </thead>
                {dashboardEntry.sort(function (a, b) {
                    var x = a.time.split(":"); var y = b.time.split(":");
                    let timex=parseInt(x[0])*3600000+parseInt(x[1])*60000+parseInt(x[2])*1000+parseInt(x[3])
                    let timey=parseInt(y[0])*3600000+parseInt(y[1])*60000+parseInt(y[2])*1000+parseInt(y[3])
                    return ((timex < timey) ? -1 : ((timex > timey) ? 1 : 0));
                }).map((entry, index) => {
                    if (entry.level == activeKey) {
                        return (
                <tbody key={index}>
                    <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            {entry.userid}
                        </th>
                        <td class="px-6 py-4">
                            {entry.name}
                        </td>
                        <td class="px-6 py-4">
                            {entry.game}
                        </td>
                        <td class="px-6 py-4">
                            {entry.date}
                        </td>
                        <td class="px-6 py-4">
                            {entry.time}
                        </td>
                    </tr>

                </tbody>
                )
                    }
                })}

            </table>
        </div>

    )
}

export default Dashboard